import { SortSelection } from '../models/SortSelection';
import { OrderByAction, SearchActionTypes } from './ActionTypes';

export function orderBy(sortSelection: SortSelection): OrderByAction {
  return {
    type: SearchActionTypes.ORDER_BY,
    sortSelection: sortSelection,
  };
}
